import ATTENDANCE from './attendance.jsx';
import EVENT      from './event.jsx';
import BUTTON     from './button.jsx';

let RSVP_CONSTS = {};

RSVP_CONSTS.ATTENDANCE = ATTENDANCE;
RSVP_CONSTS.EVENT      = EVENT;
RSVP_CONSTS.BUTTON     = BUTTON;

export default RSVP_CONSTS;